// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__OmO5d","resendInfoText":"OnGoingPaymentBox_resendInfoText__2t1YI"};